import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, BoxContainer, Icon, BoxContainerSecond, TitleHeader, TextContainer } from './styles';

const ContactAndSupport = ({ device }) => {
  const { t } = useTranslation();

  return (
    <Container device={device} data-panel='landingZD-contactSupport-container'>
      <BoxContainer device={device}>
        <Icon device={device} data-panel='landingZD-contactSupport-icon' />
        <div>
          <TitleHeader device={device} data-panel='landingZD-contactSupport-title-principal' highSize>
            {t('panel.landing_ZD.ContactAndSupport.title.principal')}
          </TitleHeader>
          <TextContainer device={device} data-panel='landingZD-contactSupport-text-principal' highSize>
            {t('panel.landing_ZD.ContactAndSupport.subtitle.principal')}
          </TextContainer>
        </div>
      </BoxContainer>
      <BoxContainerSecond device={device}>
        <div>
          <TitleHeader device={device} data-panel='landingZD-contactSupport-title-schedules'>
            {t('panel.landing_ZD.ContactAndSupport.title.schedules')}
          </TitleHeader>
          <TextContainer device={device} data-panel='landingZD-contactSupport-text-schedules'>
            {t('panel.landing_ZD.ContactAndSupport.subtitle.schedules')} <br />
            {t('panel.landing_ZD.ContactAndSupport.subtitle.schedules2')}
          </TextContainer>
        </div>
        <div>
          <TitleHeader device={device} data-panel='landingZD-contactSupport-title-contact'>
            {t('panel.landing_ZD.ContactAndSupport.title.contact')}
          </TitleHeader>
          <TextContainer device={device} data-panel='landingZD-contactSupport-text-contact'>
            {t('panel.landing_ZD.ContactAndSupport.subtitle.contact')} <br />
            {t('panel.landing_ZD.ContactAndSupport.subtitle.contact2')}
          </TextContainer>
        </div>
      </BoxContainerSecond>
    </Container>
  );
};

export default ContactAndSupport;
